//防数据泄露及页面防止打开控制台等有可能会损坏系统正常运行的	
	(function() {//未实现
		try { 
		var $_console$$ = console; 
		Object.defineProperty(window, "console", { 
		get: function() { 
		if ($_console$$._commandLineAPI) 
		throw "抱歉, 为了用户安全, 本网站已禁用console脚本功能"; 
		return $_console$$ 
		}, 
		set: function($val$$) { 
		$_console$$ = $val$$ 
		} 
		}) 
		} catch ($ignore$$) { 
		} 
	})();


// WEBPACK FOOTER //
// ./src/assets/js/universaiMethod/dataLeakagePrevention.js